import isUndefined from 'lodash/isUndefined'

const BREAKPOINTS = {
  nano: { min: 0, max: 320 },
  mini: { min: 321, max: 480 },
  small: { min: 481, max: 640 },
  medium: { min: 641, max: 1023 },
  big: { min: 1024, max: 1440 },
  large: { min: 1441 }
}

export const viewportStore = {
  namespaced: true,
  state: () => ({
    scrollY: 0,
    width: 0,
    height: 0,
    docWidth: 0
  }),
  mutations: {
    SET_SCROLL (state, scrollY) {
      state.scrollY = scrollY
    },
    SET_SIZE (state, { width, height, docWidth }) {
      state.width = width
      state.height = height
      state.docWidth = docWidth
    }
  },
  getters: {
    size ({ width, height }) {
      return { width, height }
    },
    screenSize (state) {
      const sizes = Object.keys(BREAKPOINTS)
      return sizes.find((size) => {
        const { min, max } = BREAKPOINTS[size]
        return state.width >= min && (isUndefined(max) || state.width <= max)
      }) || sizes[0]
    },
    isNanoScreen (state, getters) {
      return getters.screenSize === 'screen'
    },
    isMiniScreen (state, getters) {
      return getters.screenSize === 'mini'
    },
    isSmallScreen (state, getters) {
      return getters.screenSize === 'small'
    },
    isMediumScreen (state, getters) {
      return getters.screenSize === 'medium'
    },
    isBigScreen (state, getters) {
      return getters.screenSize === 'big'
    },
    isLargeScreen (state, getters) {
      return getters.screenSize === 'large'
    },
    isMaxNanoScreen (state, getters) {
      return getters.isNanoScreen
    },
    isMaxMiniScreen (state, getters) {
      return getters.isNanoScreen ||
        getters.isMiniScreen
    },
    isMaxSmallScreen (state, getters) {
      return getters.isNanoScreen ||
        getters.isMiniScreen ||
        getters.isSmallScreen
    },
    isMaxMediumScreen (state, getters) {
      return getters.isNanoScreen ||
        getters.isMiniScreen ||
        getters.isSmallScreen ||
        getters.isMediumScreen
    },
    isMaxBigScreen (state, getters) {
      return getters.isNanoScreen ||
        getters.isMiniScreen ||
        getters.isSmallScreen ||
        getters.isMediumScreen ||
        getters.isBigScreen
    },
    isAtLeastNanoScreen (state, getters) {
      return getters.isNanoScreen ||
        getters.isMiniScreen ||
        getters.isSmallScreen ||
        getters.isMediumScreen ||
        getters.isBigScreen ||
        getters.isLargeScreen
    },
    isAtLeastMiniScreen (state, getters) {
      return getters.isMiniScreen ||
        getters.isSmallScreen ||
        getters.isMediumScreen ||
        getters.isBigScreen ||
        getters.isLargeScreen
    },
    isAtLeastSmallScreen (state, getters) {
      return getters.isSmallScreen ||
        getters.isMediumScreen ||
        getters.isBigScreen ||
        getters.isLargeScreen
    },
    isAtLeastMediumScreen (state, getters) {
      return getters.isMediumScreen ||
        getters.isBigScreen ||
        getters.isLargeScreen
    },
    isAtLeastBigScreen (state, getters) {
      return getters.isBigScreen ||
        getters.isLargeScreen
    },
    isAtLeastLargeScreen (state, getters) {
      return getters.isLargeScreen
    },
    hasVerticalScrollbar (state) {
      return state.width > state.docWidth
    }
  }
}
